import http from "./httpService";

const endPoint = "/api/v1/MovementTypes";

export function getMovementTypes() {
    return http.get(endPoint);
}

const obj = {
    getMovementTypes
};

export default obj;


// WEBPACK FOOTER //
// ./src/services/movementTypesService.js